module.exports = __webpack_public_path__ + "img/EconomyTabUnselected_ua.c36fa4fe.webp";